import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk'
import promise from 'redux-promise'
import { logger } from 'redux-logger'

// Import reducers
import rootReducer from './reducers'

export default function configureStore() {
    const store = createStore(
        rootReducer,
        undefined,
        // applyMiddleware(thunk, promise, logger),
        applyMiddleware(thunk, promise),
    );

    return store;
}



// WEBPACK FOOTER //
// ./src/store/index.js